export default __webpack_public_path__ + "static/media/service_provider_bg.4cd6077c.jpg";